import $ from 'jquery';
window.$ = window.jQuery = $;
$(document).ready(function(){
  $(".midslider").slick({
          dots: true,
          rows: ($(".midslider .slick-slide").length >4) ? 2 : 1,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: true,
          mobileFirst: true,
          responsive: [
      {
        breakpoint: 1024,
        settings: {
        	rows: ($(".midslider .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 800,
        settings: {
        	rows: ($(".midslider .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
       rows: ($(".midslider .slick-slide").length >4) ? 2 : 1,
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true

        }
      },
      {
        breakpoint: 320,
        settings: {
          mobileFirst: true,
        	arrows: true,
        	rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:false
          }
      }
    ]
        });
  $(".midslider-home4").slick({
          dots: true,
          rows: ($(".midslider-home4 .slick-slide").length >4) ? 3 : 1,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          mobileFirst: true,
          responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: ($(".midslider-home4 .slick-slide").length >4) ? 3 : 1,
          slidesToShow: 3,
          slidesToScroll:3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          rows: ($(".midslider-home4 .slick-slide").length >4) ? 3 : 1,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
       rows: ($(".midslider-home4 .slick-slide").length >4) ? 3 : 1,
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true

        }
      },
      {
        breakpoint: 320,
        settings: {
          mobileFirst: true,
          arrows: true,
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:false
          }
      }
    ]
        });


  $(".midslider-home2").slick({
          dots: true,
          rows: ($(".midslider-home2 .slick-slide").length >4) ? 2 : 1,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          mobileFirst: true,
          responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: ($(".midslider-home2 .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 3,
          slidesToScroll:3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          rows: ($(".midslider-home2 .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
       rows: ($(".midslider-home2 .slick-slide").length >4) ? 2 : 1,
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true

        }
      },
      {
        breakpoint: 320,
        settings: {
          mobileFirst: true,
          arrows: true,
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:false
          }
      }
    ]
        });

  $(".invetorslider").slick({
          dots: true,
          rows: ($(".invetorslider .slick-slide").length >4) ? 2 : 1,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: true,
          mobileFirst: true,
          responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: ($(".invetorslider .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          rows: ($(".invetorslider .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
       rows: ($(".invetorslider .slick-slide").length >4) ? 2 : 1,
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true

        }
      },
      {
        breakpoint: 320,
        settings: {
          mobileFirst: true,
          arrows: true,
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:false
          }
      }
    ]
        });
  $(".invetorslider-home2").slick({
          dots: true,
          rows: ($(".invetorslider-home2 .slick-slide").length >4) ? 2 : 1,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          mobileFirst: true,
          responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: ($(".invetorslider-home2 .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          rows: ($(".invetorslider-home2 .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
       rows: ($(".invetorslider-home2 .slick-slide").length >4) ? 2 : 1,
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true

        }
      },
      {
        breakpoint: 320,
        settings: {
          mobileFirst: true,
          arrows: true,
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:false
          }
      }
    ]
        });
  $(".category").slick({
          dots: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        });

  $(".invetorone,.invetortwo,.invetorthree,.showcase,.showcaseitem").slick({
          dots: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
           responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 2,
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          rows: 2,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrows: true
        }
      },
      {
       rows: 2,
        breakpoint: 600,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
          arrows: true
        }
      },
      {
        breakpoint: 320,
        settings: {
          mobileFirst: true,
          arrows: true,
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
        });
  $(".testimonialslider").slick({
          dots: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        });


  $(".testimonialshow").slick({
          dots: true,
          rows: ($(".testimonialshow .slick-slide").length >4) ? 2 : 1,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          mobileFirst: true,
          responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: ($(".testimonialshow .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 800,
        settings: {
          rows: ($(".testimonialshow .slick-slide").length >4) ? 2 : 1,
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrows: false
        }
      },
      {
       rows: ($(".testimonialshow .slick-slide").length >4) ? 2 : 1,
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false

        }
      },
      {
        breakpoint: 320,
        settings: {
          mobileFirst: true,
          arrows: true,
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:false
          }
      }
    ]
        });

  $(".blogfilter").slick({
          dots: false,
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 5,
          arrows: true,
           responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 1,
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: 800,
        settings: {
          rows: 1,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrows: true
        }
      },
      {
       rows: 1,
        breakpoint: 600,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false
        }
      },
      {
        breakpoint: 320,
        settings: {
          mobileFirst: true,
          arrows: true,
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
    });

  $(window).resize(function(){
  $('.midslider,.invetorslider,.invetorone,.testimonialslider,.invetortwo,.invetorthree,.showcase,.testimonialshow,.showcaseitem').slick('setPosition');
  });
});